import React from 'react'
import "./css/Common.css";
export default function Loader() {
  return (
    <div><div className="loader"></div></div>
  )
}
